'use client';

import ErrorPage from './ErrorPage';

const text: {
  fr: {
    title: string;
    description: string;
  };
  en: {
    title: string;
    description: string;
  };
} = {
  fr: {
    title: 'Page non trouvée',
    description:
      "La page que vous cherchez n'existe pas ou a été déplacée. Veuillez vérifier l'URL ou retourner à la page d'accueil.",
  },
  en: {
    title: 'Page not found',
    description:
      "The page you're looking for doesn't exist or has been moved. Please check the URL or navigate back to the homepage.",
  },
};

export default function NotFoundPage({
  locale = 'fr',
}: {
  locale: 'fr' | 'en';
}) {
  return (
    <ErrorPage
      locale={locale}
      title={text[locale].title}
      description={text[locale as keyof typeof text].description}
      showBackButton={true}
      showHomeButton={true}
    />
  );
}
